import { Route, Switch, Redirect } from 'react-router-dom'

import PrivateRoute from './PrivateRoute'
import OnlyPublicRoute from './OnlyPublicRoute'

import NotFound from '../../pages/NotFound'

import { TRoutes } from '../../shared/const'

import Auth from '../../UI/layouts/Auth'
import Main from '../../UI/layouts/Main'
import CompanyPresentation from '../../UI/layouts/CompanyPresentation'
import Skills4Retail from '../views/public/Skills4Retail'
import SupporterActivation from '../../pages/SupporterActivation'
import CompanyEmailVerifyPage from '../../pages/CompanyEmailVerifyPage'
import CourseCertificateCheck from '../../pages/CourseCertificateCheck'
import SupporterRegister from '../../pages/SupporterRegister'
import { PublicAnnualReport, PublicPlatformReport } from '../../pages/PublicReport'
import DaVinciLabPage from '../../pages/DaVinciLab'
import Impressum from '../../pages/Legal/Impressum'
import Datenschutz from '../../pages/Legal/Datenschutz'
import Nutzungsbedingungen from '../../pages/Legal/Nutzungsbedingungen'
import Barrierefreiheit from '../../pages/Legal/Barrierefreiheit'

function Routes() {
	return (
		<Switch>
			<Route path={TRoutes.MAIN} component={CompanyPresentation} exact />

			{/*
			 * Die Lernstrecke Skills4Retail — offen ohne Anmeldung, deshalb hier
			 * oben und nicht unter der privaten Sammelroute. Wer angemeldet ist,
			 * arbeitet unter /konzept weiter; dort stehen auch die Konzeptfelder.
			 */}
			<Route path={TRoutes.PUBLIC_COURSE} component={Skills4Retail} exact />

			{/*
			 * Aktivierung einer Einladung. Bewusst eine oeffentliche Route ausserhalb
			 * von /auth: die eingeladene Person hat noch keinen Zugang und soll den
			 * Link direkt aus der E-Mail oeffnen koennen.
			 */}
			<Route path={TRoutes.SUPPORTER_ACTIVATION()} component={SupporterActivation} />

			{/*
			 * Oeffentliche Landing- und Registrierungsseite. Wird aus JAA-Mails und
			 * von der Junior-Achievement-Website verlinkt, muss also ohne Login und
			 * ausserhalb von /auth erreichbar sein.
			 */}
			<Route path={TRoutes.SUPPORTER_REGISTER} exact component={SupporterRegister} />

			{/*
			 * Die zwei offenen Fassungen des Jahresberichts. Ohne Anmeldung, weil
			 * der Aufmacher der Startseite, die Unterstuetzer:innen-Seite und der
			 * DaVinciLab-Steckbrief darauf verweisen — hinter `PrivateRoute`
			 * endete jeder dieser Verweise auf der Anmeldemaske. Angemeldete sehen
			 * dieselbe Seite (siehe BLEIBT_STEHEN in App.js).
			 */}
			<Route path={TRoutes.PUBLIC_ANNUAL_REPORT} exact component={PublicAnnualReport} />
			<Route path={TRoutes.PUBLIC_PLATFORM_REPORT} exact component={PublicPlatformReport} />
			<Route path={TRoutes.PUBLIC_DAVINCILAB} exact component={DaVinciLabPage} />

			{/*
			 * Bestaetigung der Firmen-E-Mail-Adresse. Der Knopf steht in einer Mail
			 * ans Firmenpostfach und wird oft dort geoeffnet, wo niemand angemeldet
			 * ist — hinter `PrivateRoute` endete der Klick auf der Anmeldemaske und
			 * die Adresse blieb unbestaetigt. Deshalb oeffentlich und **vor**
			 * OnlyPublicRoute/PrivateRoute: Angemeldete sehen dieselbe Seite.
			 */}
			<Route path={TRoutes.COMPANY_EMAIL_VERIFY} exact component={CompanyEmailVerifyPage} />

			{/*
			 * Prüfseite einer Kurs-Urkunde — der QR-Code auf dem Blatt führt
			 * hierher, aufgerufen meist von einem Betrieb ohne Zugang.
			 */}
			<Route path={TRoutes.COURSE_CERTIFICATE_CHECK()} exact component={CourseCertificateCheck} />

			{/*
			 * Rechtsseiten: muessen ohne Login erreichbar sein (Impressums- und
			 * Informationspflichten), deshalb vor OnlyPublicRoute/PrivateRoute.
			 */}
			<Route path={TRoutes.IMPRESSUM} exact component={Impressum} />
			<Route path={TRoutes.DATENSCHUTZ} exact component={Datenschutz} />
			<Route path={TRoutes.NUTZUNGSBEDINGUNGEN} exact component={Nutzungsbedingungen} />
			<Route path={TRoutes.BARRIEREFREIHEIT} exact component={Barrierefreiheit} />

			<OnlyPublicRoute path={TRoutes.AUTH} except={[TRoutes.AUTH_CONFIRM, TRoutes.SIGN_UP]} component={Auth} />
			<PrivateRoute path={TRoutes.MAIN} component={Main} />

			<Route exact path={TRoutes.NOT_FOUND} component={NotFound} />
			<Redirect exact from="*" to={TRoutes.NOT_FOUND} />
		</Switch>
	)
}

export default Routes
